// TODO Remove defaults
const GOOGLE_CLIENT_ID =
  import.meta.env.VITE_GOOGLE_CLIENT_ID ||
  '311223572780-ito68psevsti7pak7cqdo04n27og5dam.apps.googleusercontent.com';

const GOOGLE_REDIRECT_URI =
  import.meta.env.VITE_GOOGLE_REDIRECT_URI || `http://localhost:3000/auth/google/callback`;

const GOOGLE_SCOPES = ['https://www.googleapis.com/auth/drive.file'].join(' ');

export const getGoogleOAuthUrl = () => {
  const params = new URLSearchParams({
    client_id: GOOGLE_CLIENT_ID,
    redirect_uri: GOOGLE_REDIRECT_URI,
    response_type: 'code',
    scope: GOOGLE_SCOPES,
    access_type: 'offline',
    prompt: 'consent',
  });

  return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
};


export { GOOGLE_CLIENT_ID, GOOGLE_REDIRECT_URI };
